import { useCallback, useState } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useTranslation } from '@ibk/shared-translation';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useLazyGetBilletInfoQuery, useLazyGetBilletInfoV2Query } from '../../services/billetApi';
import { mapBilletErrorToMessage } from '../../utils/errorMessages';
function digitsOnly(value) {
    return value.replace(/\D/g, '');
}
export function useGetBilletData() {
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isBaasV2Enabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
    const [triggerV1] = useLazyGetBilletInfoQuery();
    const [triggerV2] = useLazyGetBilletInfoV2Query();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [errorGetBilletMessage, setErrorGetBilletMessage] = useState();
    const [billetInfo, setBilletInfo] = useState();
    const handleBilletError = useCallback((error) => {
        setErrorGetBilletMessage(mapBilletErrorToMessage(error, t));
    }, [t]);
    async function getBilletInfoV2(value) {
        const { data, error } = await triggerV2({ value });
        if (error) {
            handleBilletError(error);
            return;
        }
        if (data?.result) {
            setBilletInfo({ variant: 'v2', billet: data.result, document: digitsOnly(value) });
        }
        else {
            setErrorGetBilletMessage(t('invalid-code-billet-not-found-error'));
        }
    }
    async function getBilletInfoV1(value) {
        const { data, error } = await triggerV1({ value });
        if (error) {
            handleBilletError(error);
            return;
        }
        if (data?.result) {
            setBilletInfo({ variant: 'v1', billet: data.result });
        }
        else {
            setErrorGetBilletMessage(t('invalid-code-billet-not-found-error'));
        }
    }
    async function getBilletInfo(value) {
        setLoading(true);
        setErrorGetBilletMessage(undefined);
        setBilletInfo(undefined);
        if (!value) {
            setLoading(false);
            return;
        }
        try {
            if (isBaasV2Enabled) {
                await getBilletInfoV2(value);
            }
            else {
                await getBilletInfoV1(value);
            }
        }
        catch (err) {
            handleBilletError(err);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        errorGetBilletMessage,
        setErrorGetBilletMessage,
        loading,
        billetInfo,
        getBilletInfo,
        setBilletInfo,
    };
}
